import React, { Component } from 'react';

import ParticipantItem from './ParticipantItem';
import Card from "../components/Card";
import CardText from "../components/CardText";

class CartItem extends Component {

    render() {
        const {item} = this.props;

        let pricePerParticipant;
        let priceTotal;
        let priceInformation = item.properties.priceInfo ? item.properties.priceInfo : undefined;
        if (item.properties.totalPrice) {
            pricePerParticipant = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.properties.totalPrice);
            priceTotal = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.properties.totalPrice * Object.keys(item.participants).length);
        }

        return (
            <Card>
                <CardText>
                    <div class="clearfix">
                        <a class="link-reset text-dark o-25 float-right d-inline-block large pl-1" target="_blank" href={item.properties.uri}>
                            <i class="fa fa-info-circle"></i>
                        </a>
                        <h4 class="">{item.properties.titleOverride}</h4>
                    </div>
                    {item.participants && Object.entries(item.participants).map(([key, value]) => (
                        <div class="row">
                            <div class="col-8">
                                <ParticipantItem key={key} item={value} />
                            </div>
                            <div class="col-4 text-right">
                                <p>{pricePerParticipant}</p>
                            </div>
                        </div>
                    ))}
                    {pricePerParticipant ? (
                        <p class="text-right mt-1">
                            gesamt <strong>{priceTotal}</strong>
                        </p>
                    ) : null}
                    { priceInformation !== undefined ? (
                        <div class="w-100 d-flex">
                        <p class="w-50"></p>
                        <p class="text-right mt-1 text-muted text-price-info-react w-50">
                            {priceInformation}
                        </p>
                        </div>
                    ) : null}
                </CardText>
            </Card>
        );
    }
}

export default CartItem;
